export default "__VITE_ASSET__3251e529__"